@if (!associatedDocsOnly) {
  <mat-label *ngIf="primaryUploadText" style="font-weight: bold">{{ primaryUploadText }}</mat-label>
  <div class="button-controls">
    <input #fileUpload (change)="onFileSelected($event, 'P')"
           class="file-input" type="file">

    <button type="button" mat-raised-button color="primary" class="upload-btn"
            [disabled]="primaryDocumentAdded"
            (click)="fileUpload.click()">
      Add File
    </button>

    @if (!hideCancelButton && !fileUploadInProgress) {
      <button type="button" (click)="fileCancel('P')" mat-raised-button color="warn">
        Cancel
      </button>
    }
  </div>

  <table [dataSource]="primaryDataSource" mat-table>
    <ng-container matColumnDef="index">
      <th *matHeaderCellDef aria-label="Index" mat-header-cell> #</th>
      <td *matCellDef="let i = index" mat-cell> {{ i + 1 }}</td>
    </ng-container>
    <ng-container matColumnDef="name"><!--orderBy: 'name'"-->
      <th *matHeaderCellDef aria-label="Name" mat-header-cell> Name</th>
      <td *matCellDef="let file" mat-cell> {{ file.name }}</td>
    </ng-container>
    <ng-container matColumnDef="size">
      <th *matHeaderCellDef aria-label="Size" mat-header-cell> Size</th>
      <td *matCellDef="let file" mat-cell> {{ file.size }}</td>
    </ng-container>
    <ng-container matColumnDef="progress">
      <th *matHeaderCellDef aria-label="Progress" mat-header-cell> Progress</th>
      <td *matCellDef="let file" mat-cell>
        <mat-progress-bar [value]="file.progress" mode="determinate"></mat-progress-bar>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th *matHeaderCellDef aria-label="Actions" mat-header-cell></th>
      <td *matCellDef="let file" mat-cell>
        @if (!file.isFileComplete || file.error) {
          <button type="button" (click)="fileCancel('P')" mat-raised-button color="warn" [disabled]="fileUploadInProgress">
            Remove
          </button>
        }
      </td>
    </ng-container>
    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
    <!-- Row shown when there is no matching data. -->
    <tr *matNoDataRow class="mat-row">
      <td class="mat-cell" colspan="5"></td>
    </tr>
  </table>

  <div class="separator color_secondary"></div>
}

@if (showAssociatedDocuments) {
  <div>
    <mat-label>
      Do you want to Upload Associated Documents?
    </mat-label>
    <mat-radio-group name="attachAssociatedDoc" ngModel [(ngModel)]="attachAssociatedDoc" (ngModelChange)="onAttachAssociatedDocChange()">
      <mat-radio-button [value]="true">Yes</mat-radio-button>
      <mat-radio-button [value]="false">No</mat-radio-button>
    </mat-radio-group>
  </div>
}

@if (attachAssociatedDoc) {
  <div>
    <mat-label *ngIf="associatedUploadText" style="font-weight: bold">{{ associatedUploadText }}</mat-label>
    <div class="button-controls">
      <input #associatedFileUpload type="file" class="file-input"
             (change)="onFileSelected($event, 'A')" #fileUpload multiple="multiple">

      <button (click)="fileUpload.click()" class="upload-btn" color="primary" mat-raised-button type="button" [disabled]="fileUploadInProgress">
        Add Files
      </button>

      @if (!hideCancelButton && !fileUploadInProgress) {
        <button (click)="fileCancel('A', true)" color="warn" mat-raised-button type="button">
          Cancel
        </button>
      }
    </div>

    <table [dataSource]="associateDataSource" mat-table>
      <!--transfers = dataSource-->
      <ng-container matColumnDef="index">
        <th *matHeaderCellDef aria-label="Index" mat-header-cell> #</th>
        <td *matCellDef="let i = index" mat-cell> {{ i + 1 }}</td>
      </ng-container>
      <ng-container matColumnDef="name"><!--orderBy: 'name'"-->
        <th *matHeaderCellDef aria-label="Name" mat-header-cell> Name</th>
        <td *matCellDef="let file" mat-cell> {{ file.name }}</td>
      </ng-container>
      <ng-container matColumnDef="size">
        <th *matHeaderCellDef aria-label="Size" mat-header-cell> Size</th>
        <td *matCellDef="let file" mat-cell> {{ file.size }}</td>
      </ng-container>
      <ng-container matColumnDef="progress">
        <th *matHeaderCellDef aria-label="Progress" mat-header-cell> Progress</th>
        <td *matCellDef="let file" mat-cell>
          <mat-progress-bar mode="determinate" [value]="file.progress"></mat-progress-bar>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef aria-label="Actions" mat-header-cell></th>
        <td *matCellDef="let file; index as index" mat-cell>
          @if (file.error || !file.isFileComplete) {
            <button (click)="fileCancel('A', false, index)" color="warn" mat-raised-button type="button" [disabled]="fileUploadInProgress">
              Remove
            </button>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <!-- Row shown when there is no matching data. -->
      <tr *matNoDataRow class="mat-row">
        <td class="mat-cell" colspan="5"></td>
      </tr>
    </table>
  </div>
  <div class="separator color_secondary"></div>
}
